
<script>
import moment from "moment";
import { mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
const api = ClientFactory.get("budgetreport");
const apiDropdown = ClientFactory.get("dropdowns");
import UploadFile from '../../../components/files/Upload.vue';
import { VueGoodTable } from "vue-good-table";

export default {
    components: {
        UploadFile,
        VueGoodTable
    },
    data() {
        return{
            body: {
                id: -1,
                report_type_id: 0, // Công khai ngân sách
                report_name: "",
                cate_id: -1,
                report_year: "",
                publish_date: "",
                circulars_template_no: "",
                circulars_no: "",
                document_no: "",
                note: "",
                status: 1
            },

            inputPeriod: 4,
            inputPeriodDetail: 1,
            inputPublishDate: "",
            inputPublishTime: "",
            listCate: [],
            listPeriodDetail: [],
            dialog: {
                active: false,
                type: ""
            },
            attachments: {
                file_statistical: [],
                file_other: [],
                file_report: []
            },
            attachmentsFilesName: {
                file_statistical: [],
                file_other: [],
                file_report: []
            },
            listFile: [],
        }
    },
    computed: {
        listMonth() {
            return [
                {
                    label: "Tháng 1",
                    value: 1,
                },
                {
                    label: "Tháng 2",
                    value: 2,
                },
                {
                    label: "Tháng 3",
                    value: 3,
                },
                {
                    label: "Tháng 4",
                    value: 4,
                },
                {
                    label: "Tháng 5",
                    value: 5,
                },
                {
                    label: "Tháng 6",
                    value: 6,
                },
                {
                    label: "Tháng 7",
                    value: 7,
                },
                {
                    label: "Tháng 8",
                    value: 8,
                },
                {
                    label: "Tháng 9",
                    value: 9,
                },
                {
                    label: "Tháng 10",
                    value: 10,
                },
                {
                    label: "Tháng 11",
                    value: 11,
                },
                {
                    label: "Tháng 12",
                    value: 12,
                },
            ]
        },
        listQuarter() {
            return [
                {
                    label: "Quý 1",
                    value: 1,
                },
                {
                    label: "Quý 2",
                    value: 2,
                },
                {
                    label: "Quý 3",
                    value: 3,
                },
                {
                    label: "Quý 4",
                    value: 4,
                },
            ]
        },
        listHalfYear() {
            return [
                {
                    label: "6 tháng đầu năm",
                    value: 1,
                },
                {
                    label: "6 tháng cuối năm",
                    value: 2,
                },
            ]
        },
        listPeriod () {
            return [
                {
                    label: "Năm",
                    value: 4,
                },
                {
                    label: "Nửa năm",
                    value: 3,
                },
                {
                    label: "Tháng",
                    value: 1,
                },
                {
                    label: "Quý",
                    value: 2,
                },
                {
                    label: "9 tháng",
                    value: 5,
                },
            ]
        },
        file_columns() {
            return [
                {
                    label: "Loại tệp báo cáo",
                    field: "file_type_name",
                    thClass: "emu-vgt-thead-th",
                    tdClass: "emu-vgt-tbody-td",
                    width: "200px",
                },
                {
                    label: "Tên tệp tin",
                    field: "file_name",
                    thClass: "emu-vgt-thead-th",
                    tdClass: "emu-vgt-tbody-td",
                },
                {
                    label: "Hành động",
                    field: "action",
                    thClass: "emu-vgt-thead-th text-center width-status",
                    tdClass: "emu-vgt-tbody-td text-center width-status",
                    width: "100px",
                },
            ]
        }
        

    },
    methods: {
        ...mapActions("ui", ["loading", "closeLoading", "notify"]),
        periodChange() {
            if (this.body.period_type == 1) {
                this.listPeriodDetail = this.listMonth;
            } else if (this.body.period_type == 2)
                this.listPeriodDetail = this.listQuarter;
            else if (this.body.period_type == 3)
                this.listPeriodDetail = this.listHalfYear;
            else {
                this.listPeriodDetail = [{ value: -1, label: "" }];
                this.inputPeriodDetail = -1;
            } 
        },
        validator() {
            return (
                !this.errors.any() &&
                this.body.report_name !== "" &&
                this.body.document_no !== ""
            );
        },
        async getAttachments(id) {
            const response = await api.getFileByBudgetReportId(id);

            let listFile = response.data.map(file => {
                return {
                    file_id: file.file_id,
                    file_type_id: file.file_type_id,
                    file_type_name: file.file_type_name,
                    file_name: file.file_name,
                    file_url: file.file_path,
                }
            })
            return listFile
        },
        async update(){
            this.$validator.validateAll();
            console.log(this.validator())
            if (!this.validator()) {
                return this.notify({
                    error: true,
                    text: "Dữ liệu không hợp lệ. Kiểm tra lại các trường bắt buộc nhập",
                });
            }
            const attachmentFiles = {
                file_statistical: this.getListFileAsType(this.listFile, 2).concat(this.attachments.file_statistical),
                file_other: this.getListFileAsType(this.listFile, 3).concat(this.attachments.file_other),
                file_report: this.getListFileAsType(this.listFile, 1).concat(this.attachments.file_report),
            }

            console.log(attachmentFiles)

            /* if(attachmentFiles.file_statistical.length == 0) {
                return this.notify({
                    error: true,
                    text: 'Số liệu thống kê là bắt buộc ',
                });
            } */
            if(attachmentFiles.file_report.length == 0) {
                return this.notify({
                    error: true,
                    text: 'Văn bản/báo cáo là bắt buộc',
                });
            }

            this.loading(this.$vs);
            
            const publish_date = moment(this.inputPublishDate).format("DD/MM/YYYY") + " " + this.inputPublishTime;
            console.log({
                ...this.body,
                publish_date
            })
            let response = await api.updReport({
                ...this.body,
                publish_date
            });
            if (typeof response.error !== "undefined" || response.data.status === "failed") {
                this.closeLoading();
                return this.notify({
                    error: true,
                    text: response.error || response.data.message,
                });
            }
            response = await api.updFile({
                budget_report_id: this.body.id,
                file_type_id: 1,
                file_id: attachmentFiles.file_report,
                status: 1
            });
            if (typeof response.error !== "undefined" || response.data.status === "failed") {
                this.closeLoading();
                return this.notify({
                    error: true,
                    text: response.error || response.data.message,
                });
            }
            
            response = await api.updFile({
                budget_report_id: this.body.id,
                file_type_id: 2,
                file_id: attachmentFiles.file_statistical,
                status: 1
            });
            if (typeof response.error !== "undefined" || response.data.status === "failed") {
                this.closeLoading();
                return this.notify({
                    error: true,
                    text: response.error || response.data.message,
                });
            }
            
            response = await api.updFile({
                budget_report_id: this.body.id,
                file_type_id: 3,
                file_id: attachmentFiles.file_other,
                status: 1
            });
            if (typeof response.error !== "undefined" || response.data.status === "failed") {
                this.closeLoading();
                return this.notify({
                    error: true,
                    text: response.error || response.data.message,
                });
            }

            this.closeLoading();
            this.$router.back();
            return this.notify({
                text: "Cập nhật dữ liệu thành công",
            });
        },
        /**
         * Lọc những file theo kiểu file: file báo cáo, file thống kê hay file khác từ mảng tổng các files.
         */
        getListFileAsType(files, type) {
            return files.filter(f => f.file_type_id === type).map(item=> item.file_id)
        },
        displayUploadDialog(type) {
            this.dialog.active = true;
            this.dialog.type = type;
        },
        uploadDone() {
            this.dialog.active = false;
            switch(this.dialog.type) {
                case "file_report":
                    this.attachments.file_report = this.$refs.uploadDialog.fileIds.map(f=> parseInt(f));
                    this.attachmentsFilesName.file_report = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
                        return item.file.name
                    })
                break;
                case "file_statistical":
                    this.attachments.file_statistical = this.$refs.uploadDialog.fileIds.map(f=> parseInt(f));
                    this.attachmentsFilesName.file_statistical = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
                        return item.file.name
                    })
                break;
                case "file_other":
                    this.attachments.file_other = this.$refs.uploadDialog.fileIds.map(f=> parseInt(f));
                    this.attachmentsFilesName.file_other = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
                        return item.file.name
                    })
                break;
                default:
                    break
            }
        },
        removeFile(file) {
            this.listFile = this.listFile.filter(f => f.file_id !== file.file_id)
        },
    },
    async created() {
        this.loading(this.$vs);
        this.listCate = (await apiDropdown.getItemsTree('BUDGET_REPORT_CATE')).map(i => {
            return {label: i.label, value: parseInt(i.value)}});

        console.log(this.listCate)
        let id = this.$route.params.id;
        const response = await api.getById(id);
        
        ({  id: this.body.id,
            report_name: this.body.report_name, 
            cate_id: this.body.cate_id,
            period_type: this.body.period_type,
            report_year: this.body.report_year,
            period_value: this.body.period_value,
            document_no: this.body.document_no,
            circulars_no: this.body.circulars_no,
            circulars_template_no: this.body.circulars_template_no,
            publish_date: this.body.publish_date,
            note: this.body.note,
            status: this.body.status
        } = response.data[0]);

        
        
        this.inputPublishTime = this.body.publish_date.split(' ')[1];
        this.inputPublishDate = moment(this.body.publish_date, "DD/MM/YYYY").toDate()
        console.log(this.body)
        
        this.listFile = await this.getAttachments(id);
        console.log(this.listFile)
        this.periodChange();

        this.closeLoading();
    },
    destroyed() {
        this.closeLoading();
    },
}
</script>

<template>
	<div class="edit-public-budget-container">
		<CCard>
			<CCardHeader  class="pt-1 pb-1">
				<span class="card-header-title">Cập nhật báo cáo công khai ngân sách</span>
			</CCardHeader>
			<CCardBody  class="pt-1 pb-1">
				<CRow class="mb-2">
					<CCol md="6" class="mt-2">
						<CInput
							v-model="body.report_name"
							label="Tên báo cáo (*)"
							v-validate="'required'"
							name="Tên báo cáo"
						/>
						<span class="text-danger text-sm">{{
							errors.first("Tên báo cáo")
						}}</span>
					</CCol>
                    <CCol md="6" class="mt-2">
						<CSelect
							:value.sync="body.cate_id"
							label="Danh mục"
							:options="listCate"
						/>
					</CCol>
				</CRow>
				<CRow class="mb-2">
                    <CCol md="3" class="mt-2">
                        <CInput
							v-model="body.report_year"
                            type="number"
							label="Năm"
						/>
                    </CCol>
					<CCol md="3" class="mt-2">
						<CSelect
							label="Kỳ báo cáo"
							:options="listPeriod"
							:value.sync="body.period_type"
							@change="periodChange"
						/>
					</CCol>
                    <CCol sm="3" class="mt-2">
						<CSelect
							:class="body.period_type != 4 && body.period_type != 5 && body.period_type != -1 ? 'visible' : 'invisible'"
							label="Loại kỳ báo cáo"
							:options="listPeriodDetail"
							:value.sync="body.period_value"
						/>
					</CCol>
				</CRow>
                <CRow class="mb-2">
					<CCol md="3" class="mt-2">
						<CInput
							v-model="body.document_no"
							label="Số văn bản công bố"
                            name="Số văn bản công bố"
                            v-validate="'required'"
						/>
                        <span class="text-danger text-sm">{{errors.first("Số văn bản công bố")}}</span>
					</CCol>
                    <CCol md="3" class="mt-2">
						<CInput
							v-model="body.circulars_no"
							label="Số thông tư áp dụng"
                            name="Số thông tư áp dụng"
						/>
                        <span class="text-danger text-sm">{{errors.first("Số thông tư áp dụng")}}</span>
					</CCol>
                    <CCol md="2" class="mt-2">
						<CInput
							v-model="body.circulars_template_no"
							label="Biểu mẫu thông tư"
                            name="Biểu mẫu thông tư"
						/>
                        <span class="text-danger text-sm">{{errors.first("Biểu mẫu của thông tư")}}</span>
					</CCol>
                    <CCol md="2" class="mt-2">
						<label for="datepicker">Ngày công bố</label>
						<b-form-datepicker
							id="datepicker"
							v-model="inputPublishDate"
							class="mb-2"
                            locale="vi"
                            placeholder="Chọn ngày công bố"
                            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                            :hide-header=true
                            label-help=""
                            :value-as-date=true>
                        </b-form-datepicker>
					</CCol>
                    <CCol md="2" class="mt-2">
                        <label for="timepicker">Giờ công bố</label>
						<b-form-timepicker
                            id="timepicker"
                            v-model="inputPublishTime"
                            placeholder="Chọn giờ công bố"
                            hourCycle="h23"
                            :hide-header=true
                            no-close-button
                            locale="vi">
                        </b-form-timepicker>
					</CCol>
				</CRow>
                <CRow class="mb-2">
					<CCol md="12" class="mt-2">
						<CTextarea
							v-model="body.note"
							label="Ghi chú"
							rows="5"
						/>
					</CCol>
				</CRow>
                <CRow>
                    <CCol sm="12" class="mb-2"><span>File đính kèm</span></CCol>
                </CRow>
                <vue-good-table
                        :columns="file_columns"
                        :rows="listFile"
                        :sort-options="{
                            enabled: false,
                        }"
                    >
                        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
                            Không có dữ liệu
                        </div>
                        <template slot="table-row" slot-scope="props" >
                            <div v-if="props.column.field === 'action'" class="row">
                                <vs-button v-b-tooltip.hover transparent circle icon>
                                    <CLink :href="props.row.file_url" target="_blank">
                                        <span><i class="bx bx-download"></i></span>
                                    </CLink>
                                </vs-button>
                                <vs-button v-b-tooltip.hover transparent circle icon danger @click="removeFile(props.row)"><i class='bx bx-x'></i></vs-button>
                            </div>
                        </template>
                </vue-good-table>
                <CRow class="mb-2 mt-3">
                    <CCol sm="4" class="ml-0">
                        <span>Văn bản/báo cáo (*)</span>
                        <vs-button class="ml-0" square danger @click="displayUploadDialog('file_report')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
                        <span v-if="this.attachments.file_report.length > 0" style="color: #2eb85c" class="small">Đã tải lên {{this.attachments.file_report.length}} tệp tin</span>
                    </CCol>
                    <CCol sm="4">
                        <span>Số liệu thống kê</span>
                        <vs-button class="ml-0" square danger @click="displayUploadDialog('file_statistical')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
                        <span v-if="this.attachments.file_statistical.length > 0" style="color: #2eb85c;" class="small">Đã tải lên {{this.attachments.file_statistical.length}} tệp tin</span>
                    </CCol>
                    <CCol sm="4">
                        <span>Tệp đính kèm khác</span>
                        <vs-button class="ml-0" square danger @click="displayUploadDialog('file_other')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
                        <span v-if="this.attachments.file_other.length > 0" style="color: #2eb85c;" class="small">Đã tải lên {{this.attachments.file_other.length}} tệp tin</span>
                    </CCol>
                </CRow>
			</CCardBody>
            <CCardFooter>
                    <CRow>
                        <CCol md="12">
                            <div class="text-center">
                                <vs-button class="d-inline custom_btn_search" square danger @click="$router.back()"><i class="bx bx-left-arrow-alt"></i> &nbsp;Quay lại</vs-button>
                                <vs-button class="d-inline" square @click="update"><i class="bx bx-save"></i> &nbsp;Cập nhật</vs-button>
                            </div>
                        </CCol>
                    </CRow>
                </CCardFooter>
		</CCard>
        <vs-dialog prevent-close width="600px" scroll overflow-hidden v-model="dialog.active">
            <template #header>
                <h4 class="not-margin">
                <b>Tải lên</b>
                </h4>
            </template>
            <UploadFile ref="uploadDialog"/>
            <template #footer>
                <div class="con-footer flex flex-end">
                    <vs-button square success @click="$refs.uploadDialog.uploadFiles()"><i class="bx bx-cloud-upload"></i> &nbsp; Bắt đầu tải</vs-button>
                    <vs-button square danger @click="uploadDone"><i class="bx bx-save"></i> &nbsp; Xong</vs-button>
                </div>
            </template>
        </vs-dialog>
	</div>
</template>
<style lang="scss">
.edit-public-budget-container {
    .vgt-responsive {
        overflow-x: inherit;
    }
    table.vgt-table td {
        vertical-align: inherit;
        padding: 0em 0.75em 0em 0.75em;
    }
}
    
</style>